import { CDN_CMC_URI, CLOUDFRONT_URI } from "src/variable/constant";

require("round10").polyfill();
export const getQueryParams = (url) => {
  if (!url) return;
  return (url.match(/([^?=&]+)(=([^&]*))/g) ?? []).reduce((total, crr) => {
    const [key, value] = crr.split("=");
    total[key] = value;
    return total;
  }, {});
};

export const callBackUrl = (queryURL = "") => {
  return `${process.env.REACT_APP_FINAN_LOGIN}/?callback=${process.env.REACT_APP_FINAN_URL}/login/callback/chat/success${queryURL}`;
};

export const objFromArray = (array, key = "id") => {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
};

export const firstItemArray = (arr) => {
  if (!Array.isArray(arr)) return;
  return arr.slice(0, 1);
};
export const FormatNumber = (nStr, currency = "") => {
  nStr = nStr === undefined || Number.isNaN(Number(nStr)) ? "" : nStr;
  nStr = Math.round10(nStr, -5);
  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "." + x[1] : "";

  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1,$2");
  }
  return `${x1 + x2} ${currency}`;
};

// export function getFinalPrice({ normal_price, selling_price }) {
//   return selling_price || normal_price;
// }

export function getFinalPrice({
  min_normal_price,
  max_normal_price,
  min_selling_price,
  max_selling_price,
  normal_price,
  selling_price,
}) {
  return (
    min_selling_price ||
    max_selling_price ||
    min_normal_price ||
    max_normal_price ||
    selling_price ||
    normal_price
  );
}

export function getTimeZone() {
  const offset = new Date().getTimezoneOffset(),
    o = Math.abs(offset);
  return (
    (offset < 0 ? "+" : "-") +
    ("00" + Math.floor(o / 60)).slice(-2) +
    ":" +
    ("00" + (o % 60)).slice(-2)
  );
}


export function getImageSourceV2(url, op =  {
  w: 900,
  h: 900,
  fit: "crop",
}) {
  if (!url) {
    return url;
  }

  const size = "h" in op ? `${op.w}x${op.h}` : `w${op.w}`;

  if (url.includes(CLOUDFRONT_URI)) {
    return url.replace(CLOUDFRONT_URI, `${CDN_CMC_URI}/v2/${size}`);
  }

  return url.replace(CDN_CMC_URI, `${CDN_CMC_URI}/v2/${size}`);
}
